module.exports = __webpack_public_path__ + "static/media/michellewan.6b1fd9f9.jpeg";